// @flow

// The WHATWG HTML5 "valid e-mail address" pattern, i.e. what browsers apply to
// <input type='email'>. The login forms set noValidate to render their own error
// styling, so this restores the same check rather than a stricter one.
const EMAIL_PATTERN = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/

export default function validateEmail (email: string): boolean {
  return EMAIL_PATTERN.test(email)
}
